import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/internal/Subscription';
import {Link} from 'ngx-linkifyjs';
import {LinkPreview} from '../../interfaces/linkpreview.interface';
import {MatLinkPreviewService} from '../../service/mat-link-preview.service';

@Component({
  selector: 'mat-link-preview',
  template: `
    <div class="center-auto" *ngIf="!this.linkPreview && !this.loaded && this.showLoadingsProgress">
      <mat-spinner></mat-spinner>
    </div>
    <mat-card>
      <mat-card-content>
        <div class="img-container">
          <img mat-card-image [src]="linkPreview?.image">
        </div>
        <div>
          <mat-card-title>{{linkPreview?.title}}</mat-card-title>
          <mat-card-subtitle>{{linkPreview?.description}}</mat-card-subtitle>
          <a [href]="linkPreview?.url" mat-button [color]="color">{{linkPreview?.url}}</a>
        </div>
      </mat-card-content>
    </mat-card>
  `,
  styles: [`
    :host{display:inline-block}mat-card-content{box-sizing:border-box;display:flex;flex-direction:row}mat-card-content a{padding-left:0;padding-right:0}.img-container{align-items:center;box-sizing:border-box;display:flex;flex:1 1 100%;flex-direction:row;margin-right:1rem;max-width:20%;padding:24px 16px;place-content:center}.center-auto{margin-left:auto!important;margin-right:auto!important}
  `]
})
export class MatLinkPreviewComponent implements OnInit, OnDestroy {

  @Input() link: Link;
  @Input() linkPreview: LinkPreview;

  // forwarded from the container
  @Input() color = 'primary'; // accent | warn
  @Input() showLoadingsProgress = true;

  loaded: boolean;
  private _subscription: Subscription;

  constructor(public linkPreviewService: MatLinkPreviewService) {
  }

  ngOnInit(): void {
    if (this.link && !this.linkPreview) {
      this.loaded = false;
      this._subscription = this.linkPreviewService
        .fetchLink(this.link.href)
        .subscribe(value => {
          this.linkPreview = value;
          this.loaded = true;
        });
    }
  }

  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

}
